import React, { useState } from 'react';
// UI
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
// Services
import { REPORT_REASON_OPTIONS } from 'services/moderation/moderation.service';

const ReportContentDialog = ({
  open,
  onClose,
  onSubmit,
  title = 'Report content',
  submitting = false,
}) => {
  const [reason, setReason] = useState('inappropriate_content');
  const [details, setDetails] = useState('');
  const [error, setError] = useState(null);

  const handleClose = () => {
    if (submitting) return;
    setError(null);
    setDetails('');
    setReason('inappropriate_content');
    onClose();
  };

  const handleSubmit = async () => {
    if (!reason) {
      setError('Please select a reason.');
      return;
    }
    try {
      setError(null);
      await onSubmit({ reason, details: details.trim() });
      setDetails('');
      setReason('inappropriate_content');
    } catch (err) {
      setError(err.message || 'Failed to submit report.');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Reports are reviewed within 24 hours. Offending content may be removed and abusive
          users ejected from the service.
          {title.toLowerCase().includes('block')
            ? ' Submitting will also hide this user\'s posts from your feed.'
            : ''}
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="report-reason-label">Reason</InputLabel>
          <Select
            labelId="report-reason-label"
            label="Reason"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            disabled={submitting}
          >
            {REPORT_REASON_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Additional details (optional)"
          value={details}
          onChange={(event) => setDetails(event.target.value)}
          multiline
          minRows={3}
          fullWidth
          disabled={submitting}
        />
        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={handleSubmit} disabled={submitting}>
          {submitting
            ? 'Submitting…'
            : title.toLowerCase().includes('block')
              ? 'Report & block'
              : 'Submit report'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportContentDialog;
